export default {
	path: '/cctv-ai-config',
	redirect: '/cctv-ai-config',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'cctvAiConfigHome',
			component: () => import('@/views/mng/CctvAiConfig'),
		},
	],
};
